<template>
  <b-card-code v-if="$checkPermission($options.name, 'view')" id="itf-all" no-body>
    <template v-if="edit">
      <ItfForm @saved="onFormClosed" @cancel="onFormClosed" />
    </template>
    <template v-else-if="docs.print">
      <ItfPrint />
    </template>
    <template v-else>
      <ItfListGrid action-name="getAllItfs" :show-company="true" />
    </template>
  </b-card-code>
</template>

<script>
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import store from '@/store'
import itfModule from '@/store/itf/itf'
import ItfPrint from '@/views/pages/itf/docs/ItfPrint.vue'
import ItfListGrid from '@/views/pages/itf/ItfListGrid.vue'
import ItfForm from '@/views/pages/itf/ItfForm.vue'

export default {
  name: 'itf-all',
  components: {
    BCardCode,
    ItfPrint,
    ItfListGrid,
    ItfForm,
  },
  data() {
    return {
      ITF_STORE_MODULE_NAME: 'itfModule',
    }
  },
  computed: {
    docs() {
      return this.$store.state[this.ITF_STORE_MODULE_NAME].docs
    },
    edit() {
      return this.$store.state[this.ITF_STORE_MODULE_NAME].edit
    },
  },
  created() {
    if (!store.hasModule(this.ITF_STORE_MODULE_NAME)) {
      store.registerModule(this.ITF_STORE_MODULE_NAME, itfModule)
    }
  },
  methods: {
    onFormClosed() {},
  },
}
</script>
